module.exports = __webpack_public_path__ + "img/bian_icon.23d040c1.svg";